module.exports = __webpack_public_path__ + "static/media/approveCardOrdersIcon.4c4a99ba.svg";